var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingMeetingsLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.96,
    height: 20.94,
    viewBox: "0 0 13.96 20.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47336",
    "data-name": "Group 47336",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54478",
    "data-name": "Path 54478",
    d: "M92.313,0a6.981,6.981,0,0,0-6.142,10.3l5.76,10.418a.436.436,0,0,0,.763,0l5.762-10.421A6.981,6.981,0,0,0,92.313,0Zm0,10.47A3.49,3.49,0,1,1,95.8,6.98,3.494,3.494,0,0,1,92.313,10.47Z",
    transform: "translate(-85.333)",
    fill: "#9c9c9c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingMeetingsLocation);
export default __webpack_public_path__ + "static/media/upcoming-meetings-location.2c050daa013adbfa79ab70c42e01c3b4.svg";
export { ForwardRef as ReactComponent };